/**
 * Spanish unit names for Unit Conversion (ADR 0051 part 3). Keyed by the
 * literal enum values ('Metric' | 'Customary' | 'Time') rather than importing
 * `ConversionQuestionOptions`, so this module has no dependency back onto
 * MathFactsGenerator. The metric system keeps its abbreviations (mm, cm, m,
 * km, mL, L, g, kg) unchanged - they are international, not English words -
 * so only Customary and Time need their own table. Shape and factors match
 * Constants.ts's English CONVERSION_TABLE exactly; only the unit names differ.
 */
export const conversionTable: Record<string, { small: string; large: string; factor: number }[]> = {
    Metric: [
        { small: "mm", large: "cm", factor: 10 },
        { small: "cm", large: "m", factor: 100 },
        { small: "m", large: "km", factor: 1000 },
        { small: "mm", large: "m", factor: 1000 },
        { small: "mL", large: "L", factor: 1000 },
        { small: "g", large: "kg", factor: 1000 },
    ],
    Customary: [
        { small: "pulgadas", large: "pies", factor: 12 },
        { small: "pies", large: "yardas", factor: 3 },
        { small: "pulgadas", large: "yardas", factor: 36 },
        { small: "onzas", large: "libras", factor: 16 },
        { small: "tazas", large: "pintas", factor: 2 },
        { small: "pintas", large: "cuartos", factor: 2 },
        { small: "cuartos", large: "galones", factor: 4 },
        { small: "tazas", large: "cuartos", factor: 4 },
        { small: "pintas", large: "galones", factor: 8 },
    ],
    Time: [
        { small: "segundos", large: "minutos", factor: 60 },
        { small: "minutos", large: "horas", factor: 60 },
        { small: "horas", large: "días", factor: 24 },
        { small: "días", large: "semanas", factor: 7 },
    ],
};
